<template>
  <el-table :data="pileDataTable" stripe style="width: 100%" ref="pileDataTable" border
            v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="pileCode" label="桩编号"></af-table-column>
    <af-table-column prop="name" label="桩名称"></af-table-column>
    <af-table-column prop="stationName" label="所属站"></af-table-column>
    <af-table-column prop="operatorName" label="运营商"></af-table-column>
    <af-table-column prop="pileTypeModel" label="型号"></af-table-column>
    <af-table-column width="80" prop="fastOrSlow.message" label="类型"></af-table-column>
    <af-table-column width="80" prop="ratedPower" label="功率(Kw)"></af-table-column>
    <af-table-column width="70" prop="gunCount" label="枪口数量"></af-table-column>
    <af-table-column width="140" prop="serviceBillingRulesName" label="费率组"></af-table-column>
    <!--                <af-table-column width="120" label="运行状态">-->
    <!--                  <template slot-scope="{row}">-->
    <!--                    <div v-if="row.runStatus">-->
    <!--                      <el-tag :type="row.runStatus.code | statusFilter">-->
    <!--                        {{ row.runStatus.message }}-->
    <!--                      </el-tag>-->
    <!--                    </div>-->
    <!--                  </template>-->
    <!--                </af-table-column>-->
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pile:view'])">视图
        </el-button>
        <el-button size="mini" @click="pileEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pile:editPile'])">编辑
        </el-button>
<!--        <el-button size="mini" type="danger" @click="pileDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pile:deletePile'])">删除
        </el-button>-->
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      pileDataTable:{},
      listLoading:false,
    },
    methods:{
      showViewVisible(index,row){
        this.$emit("showViewVisible",index,row)
      },
      pileEdit(index,row){
        this.$emit("pileEdit",index,row)
      },
      pileDelete(index,row){
        this.$emit("pileDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager/list.vue